import { useAuth } from "../../contexts/AuthContext";
import React from "react";
import { getAvailablePredefinedFilters } from "../../services/eventService";

const useMenuLogic = () => {
  const { isAuthenticated, showAdminPanel } = useAuth();

  const isCurrentPath = (path: string, checkBase: boolean = false) => {
    const currentPath = window.location.pathname;
    return checkBase
      ? currentPath === path
      : currentPath === path || currentPath.startsWith(path + "/");
    // return currentPath === path || currentPath.startsWith(path + "/");
  };

  const [showEventAttended, setShowEventAttended] = React.useState(false);
  const [showEventVolunteered, setShowEventVolunteered] = React.useState(false);
  const [showEventHosted, setShowEventHosted] = React.useState(false);

  const [showAdminMenu, setShowAdminMenu] = React.useState(false);

  // call fetchPredefinedFilters function if user is authenticated and set showEventAttended and showEventHosted based on the response
  React.useEffect(() => {
    if (isAuthenticated) {
      fetchPredefinedFilters();
    }
  }, [isAuthenticated]);

  React.useEffect(() => {
    setShowAdminMenu(showAdminPanel);
  }, [showAdminPanel]);

  const fetchPredefinedFilters = async () => {
    try {
      const response = await getAvailablePredefinedFilters();
      const responseFilters = response.data.data.filters;
      setShowEventAttended(
        responseFilters.some((filter: string) => filter === "attended")
      );
      setShowEventVolunteered(
        responseFilters.some((filter: string) => filter === "volunteered")
      );
      setShowEventHosted(
        responseFilters.some((filter: string) => filter === "hosted")
      );
    } catch (error) {
      console.error("Error fetching predefined filters:", error);
      return [];
    }
  };

  return {
    isCurrentPath,
    isAuthenticated,
    showEventAttended,
    showEventVolunteered,
    showEventHosted,
    showAdminMenu,
  };
};

export default useMenuLogic;
